var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"user_box"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"user_title"},[_vm._v(_vm._s(this.data.help_type))]),_vm._v(" "),_c('div',{staticClass:"html",domProps:{"innerHTML":_vm._s(this.data.help_content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b682e4f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/help_center/applicants.vue
// module id = null
// module chunks = 